/*eslint-disable*/
import api from '../'

class ConversationApi {

    // GET: conversation/:id
    static show(id) {
        return api.axios.get('/conversation/' + id)
            .then(response => response.data.conversation)
    }

    //PUT: conversation/:id
    static update(id, conversation) {
        return api.axios.put('/conversation/' + id, conversation)
            .then(response => response.data.conversation)
    }

    // POST: conversation
    static create(conversation) {
        return api.axios.post('/conversation', conversation)
            .then(response => response.data.conversation);
    }

    // GET: conversation
    static list(params, cancelToken = null) {
        return api.axios.get('/conversation', {params, cancelToken})
            .then(response => response.data)
    }

    static delete(params, id) {
        return api.axios.delete('/conversation/' + id, {params})
            .then(response => response.data)
    }

    static updateSome(params) {
        return api.axios.put('/conversation', params)
            .then(response => response.data.conversations)
    }
}

export default ConversationApi;
